var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',{staticClass:"rh-form"},[_c('form-evaluationedit',{attrs:{"routes":_vm.routes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }